
/**
 * Generates a random bracelet code
 * Format: 6 alphanumeric characters, uppercase
 */
export function generateBraceletCode(): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let code = '';
  
  for (let i = 0; i < 6; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    code += characters.charAt(randomIndex);
  }
  
  return code;
}

/**
 * Formats a bracelet code for display
 * Adds GHG prefix and formats as GHG-XXXXXX
 */
export function formatBraceletCode(code: string): string {
  if (!code) return '';
  
  const cleanCode = code.replace(/^GHG-?/, '').toUpperCase();
  return `GHG-${cleanCode}`;
}

/**
 * Parses a list of reference codes
 * Removes any non-alphanumeric characters and formats consistently
 */
export function parseReferenceCodes(codesString: string): string[] {
  if (!codesString) return [];
  
  // Split by spaces, commas, or other common separators
  const codes = codesString.split(/[\s,;]+/);
  
  // Clean up each code
  return codes
    .map(code => code.replace(/[^a-zA-Z0-9]/g, '').toUpperCase())
    .filter(code => code.length > 0);
}
